import React from 'react';
import PropTypes from 'prop-types';
import PackagePanel from 'accountComponents/PackagePanel';
import WorkOrderCardPanel from 'workOrderComponents/WorkOrderCardPanel';
import MemoPanel from 'workOrderComponents/MemoPanel';
import ChargesPanel from 'chargeComponents/ChargesPanel';
import EquipmentPanel from 'equipmentComponents/EquipmentPanel';
import JustAskPanel from 'justAskComponents/JustAskPanel';
import TabbedPanels from 'panelComponents/TabbedPanels';
import WorkOrderHeader from 'workOrderComponents/WorkOrderHeader';
import OutletActionBar from 'equipmentComponents/OutletActionBar';
import JustAskSummary from 'justAskComponents/JustAskSummary';
import ChargeSummary from 'chargeComponents/ChargeSummary';
import { PANEL_CONFIG } from 'constants/panelConfig';

const workOrderDetail = (props) => {

    const {
        orderDetail,
        workOrderActions,
        orderId,
        site,
        chargeActions,
        user,
        justAskActions,
        techInventory,
        sqcActions,
        techInventoryActions,
        techInventoryLoading,
        techId,
        orderUserId
    } = props;

    const billingDetails = orderDetail.getIn(['billingDetails', 'details']);
    const collectionDetails = orderDetail.getIn(['collectionDetails', 'details', 'collectionsDetailItem']);
    const customerDetails = orderDetail.getIn(['customerDetails', 'details']);
    const outletOptimizationDetails = orderDetail.getIn(['outletOptimizationDetails', 'details']);
    const portDetail = orderDetail.getIn(['portDetails']);
    const packageDetail = orderDetail.getIn(['packageDetails']);
    const orderServiceDetail = orderDetail.getIn(['orderServices']);
    const equipmentDetails = orderDetail.getIn(['equipmentDetails']);
    const justAskDetails = orderDetail.getIn(['justAskDetails']);
    const memoDetail = orderDetail.getIn(['accountMemos']);
    const charges = orderDetail.getIn(['charges']);
    const schedulingSystemDetail = orderDetail.getIn(['schedulingSystemDetails', 'details']);
    const orderStatus = orderDetail.getIn(['orderStatus']);
    const sqcResults = orderDetail.getIn(['sqcResults']);
    const commercialDetails = orderDetail.getIn(['commercialDetails', 'details']);
    const slideIndex = orderDetail.get('slideIndex');
    const equipmentOptions = orderDetail.get('equipmentOptions');
    const pinReset = orderDetail.get('pinReset');
    const serviceTypeId = schedulingSystemDetail.getIn(['serviceOrderInfoV2', 'serviceTypeId']);
    const userId = user.getIn(['userId']);
    const orderDets = orderDetail.getIn(['orderDetails', 'details']);
    const accountOtherDetails = orderDetail.get('accountOtherDetails');
    const accountAdd = orderDetail.get('accountAdd');
    const dongleEquipmentAdd = orderDetail.get('dongleEquipmentAdd');
    const cpeEquipmentAdd = orderDetail.get('cpeEquipmentAdd');
    const equipmentHitDetails = orderDetail.getIn(["equipmentHitDetails"]);
    const refreshHitDetails = orderDetail.getIn(["refreshHitDetails"]);
    const houseEquipmentDetails = orderDetail.getIn(['houseEquipmentDetails', 'details']);

    const workOrderCardPanel = (<WorkOrderCardPanel
        key="work_order_card_panel"
        header="Order"
        detailKey="orderDetails"
        workOrderActions={workOrderActions}
        orderDetail={orderDetail}
        orderId={orderId}
        billingSystem={schedulingSystemDetail.get('billingSystem')}
        customerDetail={customerDetails}
        techId={techId} />);


    let memoPanel = null;
    let packagePanel = null;
    let equipmentPanel = null;
    if(customerDetails) {
    memoPanel = (<MemoPanel
        key="memo_panel"
        detailKey="accountMemos"
        header="Memos"
        orderId={orderId}
        memoDetail={memoDetail}
        workOrderActions={workOrderActions} />);

    packagePanel = (<PackagePanel
        orderDetails={orderDets}
        customerDetails={customerDetails}
        collectionDetails={collectionDetails}
        billingDetails={billingDetails}
        schedulingSystemDetails={schedulingSystemDetail}
        key="package_panel"
        detailKey="packageDetails"
        header="Services"
        orderId={orderId}
        packageDetail={packageDetail}
        orderServiceDetail={orderServiceDetail}
        clearWorkOrderDetail={workOrderActions.clearWorkOrderDetail}
        commercialDetails={commercialDetails}
        equipmentOptions={equipmentOptions}
        workOrderActions={workOrderActions}
        techInventoryActions={techInventoryActions}
        accountAdd={accountAdd}
        accountOtherDetails={accountOtherDetails}
        equipmentDetails={equipmentDetails} 
        dongleEquipmentAdd={dongleEquipmentAdd}
        techInventory={techInventory}
        techInventoryLoading={techInventoryLoading}
        cpeEquipmentAdd={cpeEquipmentAdd}
        orderUserId={orderUserId}
        outletOptimizationDetails={outletOptimizationDetails}
        />);
    
    equipmentPanel = (<EquipmentPanel
        key="equipment_panel"
        header="Equipment"
        detailKey="equipmentDetails"
        sqcResults={sqcResults}
        sqcActions={sqcActions}
        techInventory={techInventory}
        portDetail={portDetail}
        orderId={orderId}
        workOrderActions={workOrderActions}
        equipmentDetails={equipmentDetails}
        equipmentHitDetails={equipmentHitDetails}
        refreshHitDetails={refreshHitDetails}
        setWorkOrderSectionCollapsed
        ={workOrderActions.setWorkOrderSectionCollapsed}
        clearWorkOrderDetail={workOrderActions.clearWorkOrderDetail}
        schedulingSystemDetails={schedulingSystemDetail}
        customerDetails={customerDetails}
        houseEquipmentDetails={houseEquipmentDetails} />);
    }
    const panels = [workOrderCardPanel, memoPanel, packagePanel, equipmentPanel];

    if (customerDetails) {
        let chargesPanel = null,
            justAskPanel = null;
        chargesPanel = (<ChargesPanel
            key="charges_panel"
            header="Charges"
            detailKey="charges"
            user={user}
            accountNumber={customerDetails.getIn(['accountNumber'])}
            chargeActions={chargeActions}
            orderStatus={orderStatus}
            orderId={orderId}
            chargeOptionDetails={charges}
            clearWorkOrderDetail={workOrderActions.clearWorkOrderDetail}
            serviceTypeId={serviceTypeId}
            customerDetails={customerDetails}
            equipmentDetails={equipmentDetails}
        />);

        justAskPanel = (<JustAskPanel
            key="just_ask_panel"
            detailKey="justAskDetails"
            header="Just Ask"
            category="ExistingCustomer"
            accountNumber={customerDetails.getIn(['accountNumber'])}
            justAskDetails={justAskDetails}
            orderStatus={orderStatus}
            orderId={orderId}
            justAskActions={justAskActions}
            clearWorkOrderDetail={workOrderActions.clearWorkOrderDetail} />);
        panels.push(chargesPanel);
        panels.push(justAskPanel);

    }

    const header = (<WorkOrderHeader
        orderStatus={orderStatus}
        schedulingSystemDetail={schedulingSystemDetail}
        orderId={orderId} />);

    const fixedHeaders = {};

    fixedHeaders[PANEL_CONFIG.equipmentDetails.slideIndex] = {
        swipeableViewsMargin: '125px',
        component: (<OutletActionBar
            getTechInventoryStarted={techInventoryActions.getTechInventoryStarted}
            equipmentDetails={equipmentDetails}
            userId={userId}
            orderUserId={orderUserId}
            techInventoryLoading={techInventoryLoading}
            orderId={orderId}
            workOrderActions={workOrderActions}
            techInventory={techInventory}
            orderDetails={orderDetail.getIn(['orderDetails', 'details'])}
            schedulingSystemDetails={schedulingSystemDetail}
            pinReset={pinReset}
            equipmentHitDetails={equipmentHitDetails}
        />)
    };

    fixedHeaders[PANEL_CONFIG.justAskDetails.slideIndex] = {
        swipeableViewsMargin: '75px',
        component: (<JustAskSummary
            style={{
                display: 'inline-block'
            }}
            justAskDetails={justAskDetails} />)
    };

    fixedHeaders[PANEL_CONFIG.charges.slideIndex] = {
        swipeableViewsMargin: '75px',
        component: (<ChargeSummary charges={charges} />)
    };

    return (
        <TabbedPanels
            fixedHeaders={fixedHeaders}
            site={site}
            header={header}
            slideIndex={slideIndex}
            panels={panels}
            workOrderActions={workOrderActions}
            orderId={orderId} />
    );
};
workOrderDetail.propTypes = {
    orderDetail: PropTypes.object,
    workOrderActions: PropTypes.object,
    chargeActions: PropTypes.object,
    orderId: PropTypes.string,
    site: PropTypes.object,
    user: PropTypes.object,
    justAskActions: PropTypes.object,
    techInventory: PropTypes.object,
    sqcActions: PropTypes.object,
    techInventoryLoading: PropTypes.bool,
    techInventoryActions: PropTypes.object,
    techId: PropTypes.string,
    orderUserId: PropTypes.string
};
export default workOrderDetail;



// WEBPACK FOOTER //
// ./src/components/work-order/WorkOrderDetail.js